<template>
  <div class="card">
    <div class="card-content">
      <question-title :question="question" class="mb1"></question-title>

      <div class="select mt1 is-fullwidth">
        <select :value="choice" @input="recordAnswer">
          <option value="" disabled>Choose one</option>
          <option v-for="field in question.fields" v-bind:key="field.choice">{{
            field.choice
          }}</option>
        </select>
      </div>

      <next-button
        ref="nextButton"
        :id="question.id"
        :choice="choice"
      ></next-button>
    </div>
  </div>
</template>

<script>
import baseQuestion from "./baseQuestion";

export default {
  name: "dropdown",

  mixins: [baseQuestion],

  methods: {
    recordAnswer(e) {
      const entry = e.target.value;
      if (entry.length) {
        this.choice = entry;
        this.$store.dispatch("interview/setNext", true);
        this.$nextTick(() => {
          let btn = this.$refs.nextButton.$el;
          if (btn) {
            btn.click();
          }
        });
      }
    }
  }
};
</script>
